module.exports = __webpack_public_path__ + "static/media/click_yeol_en.2e8d9029.svg";